import Loadable from 'react-loadable';
import React, {Component} from 'react';

class Loading extends Component{

    render(props){
        return <div></div>;
    }
}

function myLoadable(opts){
    return Loadable(Object.assign({
        loading: Loading,
        delay: 200,
        timeout: 10000,
    }, opts));
}

export default myLoadable;